import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons';

const TrendBadge = ({ trend, trendType, comparisonText, className = 'portfolio-badge' }) => (
    <div
        className={`${className} ${
            trendType === 'up'
                ? 'trend-up'
                : trendType === 'down'
                    ? 'trend-down'
                    : 'trend-neutral'
        }`}
    >
        {trendType === 'up' && <CaretUpFilled />}
        {trendType === 'down' && <CaretDownFilled />}
        {trendType === 'up' && `+${trend}`}
        {trendType === 'down' && `-${trend}`}
        {trendType === 'neutral' && trend}
        <span>{comparisonText}</span>
    </div>
);

export default TrendBadge;
